// Utility: Social-Plattformen aus Backend holen und Default-Icon bestimmen
import api from '../api';

export async function getSocialPlatforms() {
  // Use the non-admin list endpoint so regular members can fetch icons
  const res = await api.get('/admin/social-platforms/list');
  return res.data || [];
}

export function matchPlatform(url, platforms) {
  if (!url || !platforms) return null;
  const u = url.toLowerCase();
  for (const p of platforms) {
    if (p.urlPattern && u.includes(p.urlPattern.toLowerCase())) return p;
  }
  // Default: Plattform mit leerem oder * urlPattern
  return platforms.find(p => !p.urlPattern || p.urlPattern === '*') || null;
}
